import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `EmpresaCentro/setLegal`, method: 'POST', body: null, token: token})
}